/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Grid from "@mui/material/Grid";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  createDynamicColumn,
  getDynamicColumn,
  getItemMaster,
  getItemTypesForStatus,
  getLocations,
  getMonthlyVendorPerformance,
  getSubModulesByRoleId,
} from "../../../../store";

// config file
import Config from "../../../../config/index";

// Cookies
import Cookies from "universal-cookie";

import { Alert, Collapse, IconButton, Modal } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import MDCard from "components/MDCard";
const cookies = new Cookies();
const desLength = Config.descriptionLength;

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Monthly = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getItemMaster,
  getItemTypesForStatus,
  itemMaster,
  getItemStatus,
  getMonthlyVendorPerformance,
  getMonthlyVendorPerformanceReducer,
  getLocations,
  getLocationsReducer,
  getDynamicColumnReducer,

  createDynamicColumn,
  getDynamicColumn,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedItemCode, setSelectedItemCode] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  useEffect(() => {
    getItemMaster(jwtToken);
  }, []);

  useEffect(() => {
    getItemTypesForStatus(jwtToken);
  }, []);

  useEffect(() => {
    getMonthlyVendorPerformance(
      selectedMonth ? selectedMonth.value : "",
      selectedItemCode ? selectedItemCode.value : "",

      jwtToken,
    );
  }, [selectedMonth, selectedItemCode]);

  useEffect(() => {
    getLocations(jwtToken);
  }, []);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let itemStatusReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "95815117-55fd-40be-ab8f-a9407d9ae1df",
  );

  let viewItemStatus = itemStatusReportModule
    ? itemStatusReportModule.actionId.includes(
        "e7b51078-d27b-4bf2-9707-efa327848bad",
      )
    : null;

  const [state, setState] = useState({
    columns: [
      { Header: "Vendor Name", accessor: "vendorName" },
      { Header: "Item Code/Des", accessor: "itemCodeDes" },
      { Header: "Month", accessor: "month" },
      { Header: "Success Rate", accessor: "successRate" },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempMonthlyVendor = [];
    let data = getMonthlyVendorPerformanceReducer.monthlyVendorPerformance.data
      ? getMonthlyVendorPerformanceReducer.monthlyVendorPerformance.data
      : [];

    setLoading(getMonthlyVendorPerformanceReducer.loading);
    data?.map((monthlyVendor) => {
      let des = monthlyVendor?.itemDescription;
      let len = desLength;
      const formatDate = new Date(monthlyVendor.cd);
      const monthlyVendorObject = {
        itemCode: monthlyVendor.itemCode,
        itemCodeDes: `${monthlyVendor.itemCode} / ${
          des ? des.substring(0, len) : ""
        }`,
        vendorName: monthlyVendor.vendorName,
        successRate: monthlyVendor.successRate,
        month: monthlyVendor.month,
      };
      tempMonthlyVendor.push(monthlyVendorObject);
    });
    // viewFG &&
    setState({ ...state, rows: tempMonthlyVendor });
  }, [getMonthlyVendorPerformanceReducer]);

  const headers = [
    {
      label: "itemCode",
      key: "itemCode",
    },
    {
      label: "itemDesc",
      key: "itemDesc",
    },
    { label: "categoryCode", key: "categoryCode" },
    { label: "controlType", key: "controlType" },
    { label: "qty", key: "qty" },
  ];

  const csvLink = {
    filename: "Item Status Report.csv",
    headers: headers,
    data: rows,
  };

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
    setSelectedLocation("");
  };
  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemCode,
        uom: item.uom,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const handleLocationChange = (selectedItemCode) => {
    setSelectedLocation(selectedItemCode);
  };

  const [locationOptions, setLocationOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = getLocationsReducer.locations
      ? getLocationsReducer.locations
      : [];
    data.map((item) => {
      tempItemCodeOptions.push({
        label: item.locationName,
        value: item.locationId,
      });
    });
    setLocationOptions(tempItemCodeOptions);
  }, [getLocationsReducer]);

  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
  };
  const monthOptions = [
    { label: "January", value: "January" },
    { label: "February", value: "February" },
    { label: "March", value: "March" },
    { label: "April", value: "April" },
    { label: "May", value: "May" },
    { label: "June", value: "June" },
    { label: "July", value: "July" },
    { label: "August", value: "August" },
    { label: "September", value: "September" },
    { label: "October", value: "October" },
    { label: "November", value: "November" },
    { label: "December", value: "December" },
  ];

  const subModuleId = "95815117-55fd-40be-ab8f-a9407d9ae1df";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getMonthlyVendorPerformance(
        selectedMonth ? selectedMonth.value : "",
        selectedItemCode ? selectedItemCode.value : "",

        jwtToken,
      );
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };
  return (
    // <DashboardLayout>
    //   <DashboardNavbar />
    <>
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* <Card> */}
            <MDBox
              display="flex"
              flexDirection={{ xs: "column", lg: "row" }}
              justifyContent="space-between"
              alignItems="center"
              p={3}
              mb={-3}
              mt={-4}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} lg={8}>
                  <MDBox
                    display="flex"
                    flexDirection={{ xs: "column", lg: "row" }}
                    mt={2}
                  >
                    <MDBox
                      width={{ xs: "125px", lg: "200px" }}
                      style={{ marginRight: "5px" }}
                    >
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Month DropDown
                      </MDTypography>
                      <Select
                        isClearable
                        placeholder="Choose One..."
                        className="select-css-for-filter"
                        maxMenuHeight={130}
                        options={monthOptions}
                        value={selectedMonth}
                        onChange={handleMonthChange}
                      />
                    </MDBox>

                    <MDBox
                      width={{ xs: "125px", lg: "200px" }}
                      style={{ marginRight: "5px" }}
                    >
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Item Code
                      </MDTypography>
                      <Select
                        isClearable
                        placeholder="Choose One..."
                        className="select-css-for-filter"
                        maxMenuHeight={130}
                        options={itemCodeOptions}
                        value={selectedItemCode}
                        onChange={handleItemCodeChange}
                      />
                    </MDBox>

                    {/* <MDBox
                        width={{ xs: "125px", lg: "200px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                           Vendor
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={130}
                        //   options={locationOptions}
                          value={selectedLocation}
                          onChange={handleLocationChange}
                        />
                      </MDBox>
                      <MDBox
                        width={{ xs: "125px", lg: "200px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                           Success Rate
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={130}
                        //   options={locationOptions}
                          value={selectedLocation}
                          onChange={handleLocationChange}
                        />
                      </MDBox> */}
                    {/* <MDBox
                        display="flex"
                        alignItems="center"
                        marginLeft={1}
                        marginTop={{ xs: 2, lg: 3 }}
                      >
                        <CSVLink {...csvLink}>
                          <DownloadDataButton
                            style={{ marginLeft: "5px" }}
                            type="button"
                            variant="outlined"
                            color="success"
                            iconOnly
                            tooltip="Download All Data"
                          >
                            <Icon>download</Icon>
                          </DownloadDataButton>
                        </CSVLink>
                      </MDBox> */}
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>

            <MDBox pt={3}>
              {loadingForDynamicColumn && (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  loading={loading}
                  hideColumns={hiddenColumsDetails}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                />
              )}
            </MDBox>
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                    // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
            {/* </Card> */}
          </Grid>
        </Grid>
      </MDBox>

      <ToastContainer />
    </>
    // </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    itemMaster: state.itemMaster,
    getItemTypeReducer: state.getItemTypeReducer,
    getLocationsReducer: state.getLocationsReducer,
    getMonthlyVendorPerformanceReducer:
      state.getMonthlyVendorPerformanceReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getItemTypesForStatus: (jwtToken) =>
      dispatch(getItemTypesForStatus(jwtToken)),
    getLocations: (jwtToken) => dispatch(getLocations(jwtToken)),
    getMonthlyVendorPerformance: (
      selectedMonth,
      selectedItemCode,

      jwtToken,
    ) =>
      dispatch(
        getMonthlyVendorPerformance(
          selectedMonth,
          selectedItemCode,

          jwtToken,
        ),
      ),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(Monthly);
